import { toastService } from "@miplatform/toast";
import { isEmpty } from "@miplatform/utils";

export const reportSuccess = (result, url, toastSuccessConfig = {}) => {
  if (!isEmpty(toastSuccessConfig)) {
    toastService.success(toastSuccessConfig);
  }

  return result;
};
